export default "__VITE_ASSET__$lEvMD$Z__"